import {
  type RemixiconComponentType,
  RiBox3Fill,
  RiCheckboxCircleFill,
  RiEditCircleFill,
  RiGridFill,
  RiInboxArchiveFill,
  RiRouteFill,
  RiRuler2Fill,
  RiScissorsLine,
  RiStackFill
} from '@remixicon/react'

import type { DetailStatus } from '../selectors/detail-status-selector/config/statuses'

import type { StandardTimes, StandardTimesKeys } from '@/api/orders/orders-types'
import { cn } from '@/lib/utils'

interface DetailFlowBadgeProps extends React.ComponentProps<'div'> {
  flowInven: keyof StandardTimes
  className?: string
  done?: boolean
}

interface FlowConfig {
  icon: RemixiconComponentType
  triggerClassName: string
  itemClassName: string
  name: DetailStatus
}

export const FLOW_CONFIG: Record<StandardTimesKeys, FlowConfig> = {
  CUTTIME: {
    icon: RiScissorsLine,
    triggerClassName: 'bg-blue-100 [&_svg]:text-blue-200 text-black-200',
    itemClassName: '[&_svg]:text-blue-200',
    name: 'cutting'
  },
  PUNCHTIME: {
    icon: RiEditCircleFill,
    triggerClassName: 'bg-red-100 [&_svg]:text-red-300 text-black-200 border-red-200',
    itemClassName: '[&_svg]:text-red-300',
    name: 'punching'
  },
  VB: {
    icon: RiRouteFill,
    triggerClassName: 'bg-cyan-100 [&_svg]:text-cyan-200 text-black-200 border-cyan-200',
    itemClassName: '[&_svg]:text-cyan-200',
    // @ts-expect-error
    name: 'variobend'
  },
  PKGT: {
    icon: RiInboxArchiveFill,
    triggerClassName: 'bg-purple-100 [&_svg]:text-purple-200 text-black-200 border-purple-200',
    itemClassName: '[&_svg]:text-purple-200',
    name: 'packaging'
  },
  FT: {
    icon: RiRouteFill,
    triggerClassName: 'bg-yellow-100 [&_svg]:text-yellow-200 text-black-200 border-yellow-200',
    itemClassName: '[&_svg]:text-yellow-200',
    name: 'forming'
  },
  ASSEMBLYTIME: {
    icon: RiInboxArchiveFill,
    triggerClassName: 'bg-purple-100 [&_svg]:text-purple-200 text-black-200 border-purple-200',
    itemClassName: '[&_svg]:text-purple-200',
    name: 'packaging'
  },
  BBTIME: {
    icon: RiStackFill,
    triggerClassName: 'bg-orange-100 [&_svg]:text-orange-300 text-black-200 border-orange-300',
    itemClassName: '[&_svg]:text-orange-300',
    name: 'siding'
  },
  TRIMACCESSTIME: {
    icon: RiRuler2Fill,
    triggerClassName: 'bg-blue-100 [&_svg]:text-blue-300 text-black-200 border-blue-300',
    itemClassName: '[&_svg]:text-blue-300',
    name: 'trim'
  },
  SOFFITTIME: {
    icon: RiGridFill,
    triggerClassName: 'bg-purple-100 [&_svg]:text-purple-200 text-black-200 border-purple-200',
    itemClassName: '[&_svg]:text-purple-200',
    name: 'soffit'
  }
}
export const DetailFlowBadge = ({ flowInven, className, done = false, ...props }: DetailFlowBadgeProps) => {
  const currentStatus = FLOW_CONFIG?.[flowInven]

  return (
    <div
      className={cn(
        'flex h-6 flex-1 items-center justify-center gap-1 rounded-full',
        currentStatus ? currentStatus?.triggerClassName : 'bg-grey-100 [&_svg]:text-grey-400 text-black-200',
        className
      )}
      {...props}
    >
      {done ? (
        <>
          <RiCheckboxCircleFill className='size-4 !text-green-200' />
          {currentStatus?.name ? currentStatus.name.charAt(0).toUpperCase() + currentStatus.name.slice(1) : ''}
        </>
      ) : (
        <>
          {currentStatus ? <currentStatus.icon className='size-4' /> : <RiBox3Fill className='size-4' />}
          {currentStatus?.name ? currentStatus.name.charAt(0).toUpperCase() + currentStatus.name.slice(1) : ''}
        </>
      )}
    </div>
  )
}
